import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-checkliste-lkt-bioclear-vario',
  templateUrl: './form-checkliste-lkt-bioclear-vario.component.html',
  styleUrls: ['./form-checkliste-lkt-bioclear-vario.component.scss', '../checklisten.scss'],
})
export class FormChecklisteLktBioclearVarioComponent implements OnInit {
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}
}
